const NOT_SENT = "The file could not be sent to storage.";

/** PUT a file to its presigned storage link, saying how much of it went out:
 * fetch cannot tell, and a 250 MB file takes minutes on a slow line. */
export function putToStorage(
  url: string,
  headers: Record<string, string>,
  file: Blob,
  onProgress: (percent: number) => void,
  signal?: AbortSignal,
): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new Error(NOT_SENT));
      return;
    }
    const xhr = new XMLHttpRequest();
    signal?.addEventListener("abort", () => xhr.abort(), { once: true });
    xhr.open("PUT", url);
    Object.entries(headers).forEach(([key, value]) =>
      xhr.setRequestHeader(key, value),
    );
    let last = -1;
    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable || event.total === 0) return;
      const percent = Math.floor((event.loaded / event.total) * 100);
      if (percent !== last) {
        last = percent;
        onProgress(percent);
      }
    };
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300
        ? resolve()
        : reject(new Error(NOT_SENT));
    xhr.onerror = () => reject(new Error(NOT_SENT));
    xhr.onabort = () => reject(new Error(NOT_SENT));
    xhr.send(file);
  });
}
